module.exports = __webpack_public_path__ + "img/theme6.a435d94e.png";